import { useMutation } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import { CouponDto, CreateCouponDto } from "libs/dto/src/coupon";
import { queryClient } from "@/client/libs/query-client";

const createCoupon = async (data: CreateCouponDto) => {
  const response = await axios.post<CouponDto>(`/coupons`, data);
  return response.data;
};

export const useCreateCoupon = () => {
  const {
    mutateAsync: createCouponFn,
    isPending: loading,
    error,
  } = useMutation({
    mutationFn: createCoupon,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["coupons"] });
    },
  });

  return { create: createCouponFn, loading, error };
};
